module.exports = __webpack_public_path__ + "img/90501208en.7aa8a6ad.png";